/* global ajax_object */
import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
$(function () {
  $('.js-products-archive').each(function () {
    initProductsFilterWithIsotope($(this));
  });
});

function initProductsFilterWithIsotope($block) {
  const $tabsWrap = $block.find('.products-archive__cats');
  const $list = $block.find('.products-archive__grid');

  // Init Isotope once per block
  const iso = new Isotope($list[0], {
    itemSelector: '.products-archive__item',
    layoutMode: 'fitRows',
    percentPosition: true,
    transitionDuration: '0.3s',
  });

  // Layout after images load
  imagesLoaded($list[0]).on('progress', () => iso.layout());

  let inflight = null;

  $tabsWrap.on('click', '.products-archive__cat', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const category = String($btn.data('filter') || 'all');

    if ($btn.hasClass('is-active')) return;

    $tabsWrap
      .find('.products-archive__cat')
      .removeClass('is-active')
      .attr('aria-selected', 'false');
    $btn.addClass('is-active').attr('aria-selected', 'true');

    if (inflight && inflight.readyState !== 4) {
      inflight.abort();
    }

    inflight = $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      dataType: 'json',
      timeout: 15000,
      data: {
        action: 'filter_archive_products',
        nonce: ajax_object.nonce,
        category,
      },
      beforeSend() {
        $list.addClass('is-loading');
      },
      success(res) {
        if (!res || !res.success) {
          console.error('AJAX response error:', res);
          return;
        }

        const $newItems = $(res.data.html).filter('.products-archive__item');

        // Always remove any old grid items managed by Isotope
        const oldItems = $list.children('.products-archive__item').get();
        if (oldItems.length) {
          iso.remove(oldItems);
        }

        if ($newItems.length) {
          // If previously showed empty-state, remove it
          $list.find('.products-archive__empty').remove();

          // Append new items + tell Isotope
          $list.append($newItems);
          iso.appended($newItems.get());

          // Relayout after images load
          imagesLoaded($list[0], () => iso.layout());
        } else {
          // No products → show server-provided empty-state markup
          $list.html(res.data.html); // contains .products-grid__empty
          // Optional: layout to settle container height
          iso.layout();
        }
      },
      error(xhr, status, error) {
        if (status !== 'abort') {
          console.error('AJAX request failed:', status, error);
        }
      },
      complete() {
        $list.removeClass('is-loading');
        inflight = null;
      },
    });
  });
}
